export const environment = {
  production: false,
  environment: 'development',
  apiUrl: 'https://api.provisao.dev.nabrasil.org.br/v1',
  notificationsApiEnabled: true,
  firebase: {
    apiKey: '***************************************',
    authDomain: '************************',
    projectId: '***********************************',
    storageBucket: '************************',
    messagingSenderId: '*********************',
    appId: '*******************************************',
    measurementId: '*********************',
  },
}; 